module.exports = __webpack_public_path__ + "img/smart_watches.c044531f.jpg";